import { XIcon } from 'lucide-react-native';
import { Pressable } from 'react-native';

import { Icon } from '@sixam/ui/icon';

type EventEditorCloseButtonProps = Readonly<{
  onPress: () => void;
  title: string;
}>;

export function EventEditorCloseButton({ onPress, title }: EventEditorCloseButtonProps) {
  return (
    <Pressable
      accessibilityLabel={`Close ${title}`}
      accessibilityRole="button"
      className="size-11 items-center justify-center rounded-full active:bg-muted"
      onPress={onPress}
    >
      <Icon as={XIcon} className="size-6 text-foreground" />
    </Pressable>
  );
}
